module.exports = __webpack_public_path__ + "static/media/right-top-background.0c5ef160.png";